module.exports = __webpack_public_path__ + "assets/img/5.785b0646.jpg";